module.exports = __webpack_public_path__ + "static/media/contact_flat.299ecb5f.jpg";